import * as React from "react";

interface CustomInfoCircleProps {
    className?: string;
    onClick?: () => void;
}

export function CustomInfoCircle(props: CustomInfoCircleProps) {
    return (
        <div {...props}>
            <svg
                width="32"
                height="32"
                viewBox="0 0 32 32"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M16 8C11.582 8 8 11.5833 8 16C8 20.4193 11.582 24 16 24C20.418 24 24 20.4193 24 16C24 11.5833 20.418 8 16 8ZM16 11.5484C16.7483 11.5484 17.3548 12.155 17.3548 12.9032C17.3548 13.6515 16.7483 14.2581 16 14.2581C15.2517 14.2581 14.6452 13.6515 14.6452 12.9032C14.6452 12.155 15.2517 11.5484 16 11.5484ZM17.8065 19.7419C17.8065 19.9557 17.6331 20.129 17.4194 20.129H14.5806C14.3669 20.129 14.1935 19.9557 14.1935 19.7419V18.9677C14.1935 18.754 14.3669 18.5806 14.5806 18.5806H14.9677V16.5161H14.5806C14.3669 16.5161 14.1935 16.3428 14.1935 16.129V15.3548C14.1935 15.1411 14.3669 14.9677 14.5806 14.9677H16.6452C16.8589 14.9677 17.0323 15.1411 17.0323 15.3548V18.5806H17.4194C17.6331 18.5806 17.8065 18.754 17.8065 18.9677V19.7419Z"
                    fill="#00608C"
                />
            </svg>
        </div>
    );
}
